import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    categories: []
}

const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        setCategoryData(state, action) {
            state.categories = action?.payload?.categories
        },
        defaultState(state, action) {
            return initialState
        }
    }
})

export const categoryActions = categorySlice.actions
export default categorySlice